/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierRegenerateMarketingInfoRequest
 */
export interface CourierRegenerateMarketingInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof CourierRegenerateMarketingInfoRequest
     */
    courierId: string;
}

/**
 * Check if a given object implements the CourierRegenerateMarketingInfoRequest interface.
 */
export function instanceOfCourierRegenerateMarketingInfoRequest(value: object): value is CourierRegenerateMarketingInfoRequest {
    if (!('courierId' in value) || value['courierId'] === undefined) return false;
    return true;
}

export function CourierRegenerateMarketingInfoRequestFromJSON(json: any): CourierRegenerateMarketingInfoRequest {
    return CourierRegenerateMarketingInfoRequestFromJSONTyped(json, false);
}

export function CourierRegenerateMarketingInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierRegenerateMarketingInfoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'courierId': json['courierId'],
    };
}

export function CourierRegenerateMarketingInfoRequestToJSON(json: any): CourierRegenerateMarketingInfoRequest {
    return CourierRegenerateMarketingInfoRequestToJSONTyped(json, false);
}

export function CourierRegenerateMarketingInfoRequestToJSONTyped(value?: CourierRegenerateMarketingInfoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courierId': value['courierId'],
    };
}

